<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="true"
      max-width="400"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" class="info" color="white"
          >Category
          <v-icon right>fas fa-sitemap</v-icon>
        </v-btn>
      </template>
      <v-card class="" max-width="400">
        <v-card-title>
          <v-toolbar class="teal darken-4 white--text">
            <v-toolbar-title>Create {{ Category }} Category</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" :disabled="clicked" @click="close" icon small>
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="CategForm" class="mt-2">
            <v-text-field
              outlined
              v-model.trim="CategName"
              :rules="[rules.required]"
              label="Category Name"
              id="categoryName"
            ></v-text-field>

            <p class="font-weight-black mt-3 text-center" v-html="msgError"></p>
            <v-btn
              block
              @click="OnCategAdd"
              :loading="clicked"
              class="elevation-6"
              rounded
              color="teal darken-3"
              dark
              width="150"
              >Save</v-btn
            >
          </v-form>
          <v-card-actions> </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  // AccCharts
  props: {
    Category: { type: String, required: true },
    // AccountType: { type: Number, required: true },
    loadFunction: { type: Function },
  },

  data() {
    return {
      URL: "/AccCharts/Category",
      dialog: false,
      msgError: "",
      clicked: false,
      CategName: "",
      rules: {
        required: value => !!value || "Required.",
      },
      //   dialog: false,
    };
  },

  methods: {
    close() {
      this.dialog = false;
      // this.$emit("OwnerViewClose", false);
      this.msgError = "";
    },
    OnCategAdd() {
      this.msgError = "";
      if (this.$refs.CategForm.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.URL,
            data: {
              // AccountType: this.AccountType,
              // category: this.Category,
              AccountName: this.CategName.toUpperCase(),
            },
          })
          .then(() => {
            this.clicked = false;
            this.$refs.CategForm.reset();
            this.loadFunction();
            this.close();
            // console.log(result);
            // this.AllSuppliers = result.data;
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
span {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
